export const mbToGb = data => data / 1024
